import api from "./axios";

export const gethosts = async () => {
  return api.get("/users/hosts");
};

export const getAllBlacklist = async () => {
  return api.get("/users/blacklist");
};

export const addToBlacklist = async (data: any) => {
  return api.post(`/users/blacklist/add`, data);
};

export const blacklistExist = async (id: number) => {
  return api.get(`/users/blacklist/${id}/check`);
};

export const revokeBlacklistStatus = async (id: number) => {
  return api.put(`/users/blacklist/${id}/revoke`);
};
